import { render } from "./stu-cardname.vue?vue&type=template&id=672afa49&scoped=true"
import script from "./stu-cardname.vue?vue&type=script&lang=js"
export * from "./stu-cardname.vue?vue&type=script&lang=js"

import "./stu-cardname.vue?vue&type=style&index=0&id=672afa49&lang=scss&scoped=true"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672afa49"]])

export default __exports__